
/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require("trix")
require("@rails/actiontext")
require("@rails/activestorage").start()
require("chartkick").use(require("highcharts"))
require("chart.js")
require('./nested_forms/add_fields')

import { Turbo } from "@hotwired/turbo-rails"
import Bridge from "turbo/bridge.js"

import Highcharts from "highcharts"
require("highcharts/modules/accessibility")(Highcharts)

// Chartkick 3.x has no Turbo support — chart instances accumulate across navigations,
// leaking memory until the WKWebView process is killed (blank/frozen pages on iOS).
// After each page load, destroy orphaned Highcharts instances whose containers are no
// longer in the DOM. This avoids interfering with Turbo Frame renders.
document.addEventListener('turbo:load', function() {
  for (var i = Highcharts.charts.length - 1; i >= 0; i--) {
    var chart = Highcharts.charts[i];
    if (chart && (!chart.renderTo || !document.body.contains(chart.renderTo))) {
      chart.destroy();
    }
  }
});

// Prevent inline script event listener accumulation across Turbo navigations.
// Inline <script> blocks in ERB templates add document.addEventListener calls that
// persist across navigations (document is never replaced). Over time, hundreds of
// stale listeners fire on every event, freezing the browser/WKWebView.
// This tracks listeners added by inline scripts (after application.js finishes)
// and removes them when a new page visit starts.
(function() {
  var trackedListeners = [];
  var tracking = false;
  var origAdd = Document.prototype.addEventListener;
  var origRemove = Document.prototype.removeEventListener;

  Document.prototype.addEventListener = function(type, listener, options) {
    if (tracking) {
      trackedListeners.push({ type: type, listener: listener, options: options });
    }
    return origAdd.call(this, type, listener, options);
  };

  // Start tracking after application.js and all synchronous scripts finish.
  setTimeout(function() { tracking = true; }, 0);

  // Remove all tracked listeners when a full page Turbo visit starts.
  // turbo:visit only fires for page visits, not frame navigations.
  origAdd.call(document, 'turbo:visit', function() {
    trackedListeners.forEach(function(entry) {
      origRemove.call(document, entry.type, entry.listener, entry.options);
    });
    trackedListeners = [];
  });
})();

import flatpickr from "flatpickr";

Trix.config.blockAttributes.section = { tagName: "section", nestable: true }

addEventListener("trix-initialize", event => {
  const buttonHTML  = '<button type="button" class="trix-button trix-button--insert-spoiler" data-trix-attribute="spoiler" data-trix-action="insertSpoiler" title="Spoiler">Spoiler</button>'
  const toolbarElement = event.target.toolbarElement
  const groupElement = toolbarElement.querySelector(".trix-button-group--block-tools")
  groupElement.insertAdjacentHTML("beforeend", buttonHTML)
  toolbarElement.querySelector('[data-trix-action="insertSpoiler"]').addEventListener('click', function() {
    const editor = event.target.editor
    var range = event.target.editor.getSelectedRange();

    const spoilerStartTag = '<spoiler>';
    const spoilerEndTag = '</spoiler>';
    const spoilerTagLength = spoilerStartTag.length + spoilerEndTag.length;

    if (range[0] === range[1]) {
      editor.insertString(spoilerStartTag + spoilerEndTag);
      editor.setSelectedRange([range[0] + spoilerStartTag.length, range[0] + spoilerStartTag.length]);
    } else {
      const selectedText = editor.getDocument().toString().slice(range[0], range[1]);
      editor.insertString(spoilerStartTag + selectedText + spoilerEndTag);
      editor.setSelectedRange([range[0], range[0] + spoilerTagLength + selectedText.length]);
    }
  });
})

addEventListener("trix-initialize", (event) => {
  const trixEditor = event.target;
  const dialog = trixEditor.parentElement.querySelector("trix-dialog[data-trix-dialog='href']");
  if (!dialog) return;

  const hrefInput = dialog.querySelector("input[name='href']");
  if (!hrefInput) return;

  trixEditor.addEventListener("trix-dialog-show", (e) => {
    if (e.target === dialog) {
      hrefInput.required = true;
    }
  });

  trixEditor.addEventListener("trix-dialog-hide", (e) => {
    if (e.target === dialog) {
      hrefInput.required = false;
    }
  });
});

Highcharts.setOptions({
  time: {
    useUTC: false
  },
  lang: {
    numericSymbols: [null, "M", "G", "T", "P", "E"]
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: true,
        formatter: function () {
          // if last point
          if(this.point === this.series.data[this.series.data.length-1] && (this.series.name.includes("mood map") || this.series.name.includes("friends"))) {
            return this.series.name;
          }
        }
      }
    }
  },
  chart: {
    style: {
      fontFamily: "Poppins"
    }
  }
});

Chart.defaults.global.defaultFontFamily = "Poppins"

window.Turbo = Turbo;
window.bridge = Bridge;

document.addEventListener("turbo:load", function() {
  const params = new URLSearchParams(window.location.search);
  if (params.get('scroll_to')) {
    const element = document.getElementById(params.get('scroll_to'));
    if (element) element.scrollIntoView();
  }
});


function initializeBrEmojiPicker() {
  const emojiPicker = document.getElementById('br-emoji-picker');
  const mainContent = document.querySelector('main');
  let lastButton;

  document.body.addEventListener('click', (event) => {
    const button = event.target.closest('.br-emoji-picker-button');
    if (!button) return;

    const targetId = button.getAttribute('data-target');
    const target = document.getElementById(targetId);

    if (emojiPicker.style.display === 'block' && lastButton === button) {
      emojiPicker.style.display = 'none';
      mainContent.style.marginBottom = '0px';
    } else {
      emojiPicker.style.position = 'absolute';
      emojiPicker.style.display = 'block';
      mainContent.style.marginBottom =`${emojiPicker.offsetHeight}px`;
      target.appendChild(emojiPicker);
      emojiPicker.focus();
    }

    lastButton = button;
  });

  if (emojiPicker) {
    emojiPicker.addEventListener('emoji-click', (event) => {
      const commentPane = event.target.closest('.buddy-read-comment-pane');
      if (!commentPane) return;

      const commentId = commentPane.dataset.commentId;
      const emojiUnicode = event.detail.unicode;

      const data = { emoji: emojiUnicode, comment_id: commentId };
      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

      fetch('/buddy_read_comment_reactions', {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Content-Type': 'application/json',
          'Accept': 'text/vnd.turbo-stream.html',
        },
        body: JSON.stringify(data)
      })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))
      .catch(error => console.error('Error:', error));
    });
  }
}

document.addEventListener('turbo:load', initializeBrEmojiPicker);
document.addEventListener('turbo:frame-load', initializeBrEmojiPicker);

function initializeRfEmojiPicker() {
  const rfEmojiPicker = document.getElementById('rf-emoji-picker');
  const mainContent = document.querySelector('main');
  let lastButton;

  document.body.addEventListener('click', (event) => {
    const button = event.target.closest('.rf-emoji-picker-button');
    if (!button) return;

    const targetId = button.getAttribute('data-target');
    const target = document.getElementById(targetId);

    if (rfEmojiPicker.style.display === 'block' && lastButton === button) {
      rfEmojiPicker.style.display = 'none';
      mainContent.style.marginBottom = '0px';
    } else {
      rfEmojiPicker.style.position = 'absolute';
      rfEmojiPicker.style.display = 'block';
      mainContent.style.marginBottom = `${rfEmojiPicker.offsetHeight}px`;
      target.appendChild(rfEmojiPicker);
      rfEmojiPicker.focus();
    }

    lastButton = button;
  });

  if (rfEmojiPicker) {
    rfEmojiPicker.addEventListener('emoji-click', (event) => {
      const commentPane = event.target.closest('.readalong-forum-comment-pane');
      if (!commentPane) return;

      const commentId = commentPane.dataset.commentId;
      const emojiUnicode = event.detail.unicode;

      const data = { emoji: emojiUnicode, comment_id: commentId };
      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

      fetch('/readalong_forum_comment_reactions', {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Content-Type': 'application/json',
          'Accept': 'text/vnd.turbo-stream.html',
        },
        body: JSON.stringify(data)
      })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))
      .catch(error => console.error('Error:', error));
    });
  }
}

document.addEventListener('turbo:load', initializeRfEmojiPicker);
document.addEventListener('turbo:frame-load', initializeRfEmojiPicker);

function initializeBcEmojiPicker() {
  const bcEmojiPicker = document.getElementById('bc-emoji-picker');
  const mainContent = document.querySelector('main');
  let lastButton;

  document.body.addEventListener('click', (event) => {
    const button = event.target.closest('.bc-emoji-picker-button');
    if (!button) return;

    const targetId = button.getAttribute('data-target');
    const target = document.getElementById(targetId);

    if (bcEmojiPicker.style.display === 'block' && lastButton === button) {
      bcEmojiPicker.style.display = 'none';
      mainContent.style.marginBottom = '0px';
    } else {
      bcEmojiPicker.style.position = 'absolute';
      bcEmojiPicker.style.display = 'block';
      mainContent.style.marginBottom = `${bcEmojiPicker.offsetHeight}px`;
      target.appendChild(bcEmojiPicker);
      bcEmojiPicker.focus();
    }

    lastButton = button;
  });

  if (bcEmojiPicker) {
    bcEmojiPicker.addEventListener('emoji-click', (event) => {
      const commentPane = event.target.closest('.book-club-forum-comment-pane');
      if (!commentPane) return;

      const commentId = commentPane.dataset.commentId;
      const emojiUnicode = event.detail.unicode;

      const data = { emoji: emojiUnicode, comment_id: commentId };
      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

      fetch('/book_club_forum_comment_reactions', {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Content-Type': 'application/json',
          'Accept': 'text/vnd.turbo-stream.html',
        },
        body: JSON.stringify(data)
      })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))
      .catch(error => console.error('Error:', error));
    });
  }
}

document.addEventListener('turbo:load', initializeBcEmojiPicker);
document.addEventListener('turbo:frame-load', initializeBcEmojiPicker);

if (navigator.serviceWorker && process.env.RAILS_ENV !== 'test') {
  window.addEventListener('load', function() {
    navigator.serviceWorker.register('/serviceworker.js', { scope: '/' })
      .then(function(reg) {
        console.log('[Companion]', 'Service worker registered!');
      });
  });
}

document.addEventListener("turbo:load", () => {
  const headerHeight = document.querySelector("#navbar").offsetHeight;
  const additionalSpacing = 10; // Optional: Add extra spacing if needed.

  const smoothScrollTo = (targetY, duration) => {
    const startingY = window.pageYOffset;
    const diff = targetY - startingY;
    let start;

    window.requestAnimationFrame(function step(timestamp) {
      if (!start) start = timestamp;
      const time = timestamp - start;
      const percent = Math.min(time / duration, 1);
      window.scrollTo(0, startingY + diff * percent);

      if (time < duration) {
        window.requestAnimationFrame(step);
      }
    });
  };

  let observer;

  const applyAnchorOffset = () => {
    if (location.hash.length !== 0) {
      const targetElement = document.querySelector(`[id='${location.hash.substring(1)}']`);
      if (targetElement) {
        const targetY = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight - additionalSpacing;
        smoothScrollTo(targetY, 200); // Scroll faster

        // If the target element is found, disconnect the observer
        if (observer) {
          observer.disconnect();
        }
      }
    }
  };

  // Create a new observer and set it up to apply the offset when the DOM changes
  observer = new MutationObserver((mutationsList, observer) => {
    for(let mutation of mutationsList) {
      if(mutation.addedNodes.length) {
        applyAnchorOffset();
      }
    }
  });

  // Start observing the document with the configured parameters
  observer.observe(document.body, { childList: true, subtree: true });

  // Apply anchor offset after Turbo Drive updates the DOM
  document.addEventListener("turbo:render", applyAnchorOffset);

  // Also apply anchor offset after the page has fully loaded
  document.addEventListener("turbo:load", applyAnchorOffset);

  // Disconnect the observer after 5 seconds, if it hasn't been disconnected already
  setTimeout(() => {
    if (observer) {
      observer.disconnect();
    }
  }, 5000);

  document.querySelectorAll("#select-chart-type").forEach((item) => {
    item.addEventListener("change", (event) => {
      event.preventDefault();
      setTimeout(function(){
        applyAnchorOffset();
      }, 1);
    });
  });
});


$(document).on('turbo:load',function(event){
  // scroll to matching named element in hash
  if(window.location.hash){
    var tags = document.getElementsByName(window.location.hash.slice(1))
    if(tags.length > 0){
      tags[0].scrollIntoView(true);
    }
  }
});

document.addEventListener('turbo:load', function () {
  const printCheckbox = document.getElementById('format_print');
  const printOptions = document.getElementById('print-options');
  const paperbackCheckbox = document.getElementById('format_paperback');
  const hardcoverCheckbox = document.getElementById('format_hardcover');

  function togglePrintOptions() {
    if (printCheckbox.checked) {
      printOptions.style.display = 'block';
      paperbackCheckbox.checked = true;
      hardcoverCheckbox.checked = true;
    } else {
      printOptions.style.display = 'none';
      paperbackCheckbox.checked = false;
      hardcoverCheckbox.checked = false;
    }
  }

  if (printCheckbox) {
    printCheckbox.addEventListener('change', togglePrintOptions);
    togglePrintOptions();
  }
});

$(document).on('click', '#user-menu', function(e) {
  var menu = document.getElementById("user-menu-dropdown");
  menu.classList.toggle("hidden");
})

$(document).on('click', '#toggle-mobile-menu, .mobile-menu-item', function(e) {
  var openIcon = document.getElementById("open-mobile-menu");
  var notificationsIndicator = document.getElementById("notifications-unread-indicator");
  var closeIcon = document.getElementById("close-mobile-menu");
  var mobileMenu = document.getElementById("mobile-menu");
  var menuButton = document.getElementById("toggle-mobile-menu");
  var menuButtonText = document.getElementById("menu-button-text");

  openIcon.classList.toggle("hidden");
  if (notificationsIndicator) {
    notificationsIndicator.classList.toggle("hidden");
  }
  closeIcon.classList.toggle("hidden");
  mobileMenu.classList.toggle("hidden");

  var isExpanded = menuButton.getAttribute("aria-expanded") === "true";
  menuButton.setAttribute("aria-expanded", !isExpanded);
  menuButtonText.textContent = isExpanded ? "Open main menu" : "Close main menu";
})

$(document).on('click', '.highcharts-point', function(e) {
  const isCustomTabActiveLargeScreen = $('[data-tab="custom"]').hasClass('active');
  const isCustomTabActiveSmallScreen = $('#stats-dashboard-tabs option.active').val() === 'custom';
  const isCustomTabActive = isCustomTabActiveLargeScreen || isCustomTabActiveSmallScreen;

  var point = e.originalEvent.point
  var chartID = e.target.parentNode.parentNode.parentNode.parentNode.parentNode.id

  if (chartID == "read_date_vs_pub_year_chart" ) { return }
  if (chartID == "read_date_vs_pub_year_chart_dark" ) { return }

  var isRatingChart = $(`#${chartID}`).closest('.rating-distribution-chart').length > 0;

  if (isRatingChart && point) {
    var ratingRange = point.category || point.name;
    var userId = $(`#${chartID}`).closest('.rating-distribution-chart').data('user-id');
    var bookId = $(`#${chartID}`).closest('.rating-distribution-chart').data('book-id');

    if (ratingRange && (userId || bookId)) {
      var ratingRanges = $(`#${chartID}`).closest('.rating-distribution-chart').data('rating-ranges');
      if (ratingRanges && point.index != null) {
        ratingRange = ratingRanges[point.index];
      } else {
        ratingRange = ratingRange.replace(/[⭐️★☆🌟✨]/g, '').trim();
      }
      var currentParams = new URLSearchParams(window.location.search);
      var currentRange = currentParams.get('rating_range');
      var isToggleOff = currentRange === ratingRange;
      var basePath = userId ? `/user_reviews/${userId}` : `/book_reviews/${bookId}`;

      var newParams = new URLSearchParams();
      if (!isToggleOff) {
        newParams.set('rating_range', ratingRange);
      }
      var checkbox = document.getElementById('explanation_reviews_only');
      if (checkbox && checkbox.checked) {
        newParams.set('written_explanations_only', 'true');
      }
      var currentSort = currentParams.get('sort');
      if (currentSort) {
        newParams.set('sort', currentSort);
      }
      var url = newParams.toString() ? `${basePath}?${newParams.toString()}` : basePath;
      var alreadyOnReviewsPage = window.location.pathname.startsWith(basePath);
      // If already on the reviews page, navigate via turbo frame to avoid
      // pushing a new native screen on Turbo Native. Falls back to Turbo.visit
      // if the frame isn't found (e.g. navigating from stats page).
      var frame = alreadyOnReviewsPage && (document.getElementById('book-reviews-content') || document.getElementById('user-reviews-content'));
      if (frame) {
        var spinner = document.getElementById('book-reviews-loading') || document.getElementById('user-reviews-loading');
        var reviewsPane = document.getElementById('book_reviews') || document.querySelector('.review-panes');
        if (spinner) spinner.classList.remove('hidden');
        if (reviewsPane) reviewsPane.classList.add('hidden');
        frame.src = url;
      } else {
        window.Turbo.visit(url, { action: 'advance' });
      }
    }
  }

  var chartType = $(`#${chartID}`).prevAll('.chart-type').first().text();
  if (!isCustomTabActive && (chartType == "Number of books and pages" || chartType == "")) { return }

  if (point) {
    var label = point.category || point.name;
    if (isCustomTabActive) {
      var userId = $(`#${chartID}`).prevAll('.user_id_for_segment').first().text();
      var customChartId = $(`#${chartID}`).prevAll('.custom_chart_id_for_segment').first().text();
      const currentUrl = new URL(window.location.href);
      const newPath = `/stats/${userId}/custom/segment`;

      let searchParams = new URLSearchParams(currentUrl.search);

      searchParams.set('chart_id', customChartId);
      searchParams.set('label', label);

      const segmentUrl = `${currentUrl.origin}${newPath}?${searchParams.toString()}`;
      window.Turbo.visit(segmentUrl);
    } else {
      label = label.replace("<","")
      label = label.replace("+","")
      label = label.replace("'","%27")
      if (window.location.href.indexOf("stats/tags/compare") > -1) {
        var tagId = $(`#${chartID}`).prevAll('.tag_id_for_segment').first().text();
        $.post('/stats/tags/' + tagId +'/segment', { chart_type: chartType, label: label });

      } else if (window.location.href.indexOf("stats/tags/") > -1) {
        var tagId = window.location.pathname.replace("/stats/tags/", "");
        $.post('/stats/tags/' + tagId +'/segment', { chart_type: chartType, label: label });

      } else if (window.location.href.indexOf("compare") > -1) {
        var statsType = $(`#${chartID}`).prevAll('.stats_type_for_segment').first().text();
        var userId = $(`#${chartID}`).prevAll('.user_id_for_segment').first().text();

        if (statsType == "Read Books" ) {
          var year = $(`#${chartID}`).prevAll('.year_for_segment').first().text();
          var month = $(`#${chartID}`).prevAll('.month_for_segment').first().text();
          var startDate = $(`#${chartID}`).prevAll('.start_date_for_segment').first().text();
          var endDate = $(`#${chartID}`).prevAll('.end_date_for_segment').first().text();
          if ((year == "-1") && startDate && endDate) {
            $.post('/stats/segment', { chart_type: chartType, label: label, year: year, start_date: startDate, end_date: endDate, read_status: "Read", user_id: userId });
          } else {
            $.post('/stats/segment', { chart_type: chartType, label: label, year: year, month: month, read_status: "Read", user_id: userId });
          }
        } else if (statsType == "To-Read Pile") {
          $.post('/stats/segment', { chart_type: chartType, label: label, year: year, month: month, read_status: "To-Read", user_id: userId });
        } else if (statsType == "DNF Books") {
          $.post('/books-dnf/stats/segment', { chart_type: chartType, label: label, user_id: userId });
        } else if (statsType == "Owned Books") {
          $.post('/owned-books/stats/segment', { chart_type: chartType, label: label });
        } else if (statsType == "Moods") {
          var mood = $(`#${chartID}`).prevAll('.mood_for_segment').first().text();
          $.post('/stats/segment', { segment_type: "mood", segment_name: mood, chart_type: chartType, label: label, user_id: userId });
        } else if (statsType == "Fiction/Nonfiction") {
          var bookType = $(`#${chartID}`).prevAll('.book_type_for_segment').first().text();
          $.post('/stats/segment', { segment_type: "fiction/nonfiction", segment_name: bookType, chart_type: chartType, label: label, user_id: userId });
        } else if (statsType == "Genres") {
          var genre = $(`#${chartID}`).prevAll('.genre_for_segment').first().text();
          $.post('/stats/segment', { segment_type: "genre", segment_name: genre, chart_type: chartType, label: label, user_id: userId });
        } else if (statsType.startsWith("Star")) {
          var rating = $(`#${chartID}`).prevAll('.rating_for_segment').first().text();
          $.post('/stats/segment', { segment_type: "rating", segment_name: rating, chart_type: chartType, label: label, user_id: userId });
        } else if (statsType == "Tags") {
          var tagId = $(`#${chartID}`).prevAll('.tag_id_for_segment').first().text();
          var tag = $(`#${chartID}`).prevAll('.tag_for_segment').first().text();
          $.post('/stats/tags/' + tagId +'/segment', {  segment_type: "tag", segment_name: tag, chart_type: chartType, label: label, user_id: userId });
        }
      } else if (window.location.href.indexOf("stats_type=Owned") > -1) {
        $.post('/owned-books/stats/segment', { chart_type: chartType, label: label });

      } else if (window.location.href.indexOf("stats_type=DNF") > -1) {
        var userId = window.location.pathname.match(/\/(?:stats|books-dnf)\/([^\/]+)(\/|$)/)[1]
        $.post('/books-dnf/stats/segment', { chart_type: chartType, label: label, user_id: userId });

      } else if (window.location.href.indexOf("stats_type=Moods") > -1) {
        const urlParams = new URLSearchParams(window.location.search);
        var mood = urlParams.get("mood");
        var userId = window.location.pathname.replace("/stats/", "").replace("/custom", "");
        $.post('/stats/segment', { segment_type: "mood", segment_name: mood, chart_type: chartType, label: label, user_id: userId });

      } else if (window.location.href.indexOf("stats_type=Fiction") > -1) {
        const urlParams = new URLSearchParams(window.location.search);
        var bookType = urlParams.get("book_type");
        var userId = window.location.pathname.replace("/stats/", "").replace("/custom", "");
        $.post('/stats/segment', { segment_type: "fiction/nonfiction", segment_name: bookType, chart_type: chartType, label: label, user_id: userId });

      } else if (window.location.href.indexOf("stats_type=Genres") > -1) {
        const urlParams = new URLSearchParams(window.location.search);
        var genre = urlParams.get("genre");
        var userId = window.location.pathname.replace("/stats/", "").replace("/custom", "");
        $.post('/stats/segment', { segment_type: "genre", segment_name: genre, chart_type: chartType, label: label, user_id: userId });

      } else if (window.location.href.indexOf("stats_type=Tags") > -1) {
        const urlParams = new URLSearchParams(window.location.search);
        var tag = urlParams.get("tag");
        var tagId = $(`#${chartID}`).prevAll('.tag_id_for_segment').first().text();
        var userId = window.location.pathname.replace("/stats/", "");
        $.post('/stats/tags/' + tagId +'/segment', {  segment_type: "tag", segment_name: tag, chart_type: chartType, label: label, user_id: userId });

      } else if (window.location.href.indexOf("stats_type=Star") > -1) {
        const urlParams = new URLSearchParams(window.location.search);
        var rating = urlParams.get("rating");
        var userId = window.location.pathname.replace("/stats/", "").replace("/custom", "");
        $.post('/stats/segment', { segment_type: "rating", segment_name: rating, chart_type: chartType, label: label, user_id: userId });

      } else {
        const urlParams = new URLSearchParams(window.location.search);
        var year = urlParams.get("year");
        var month = urlParams.get("month");
        var startDate = urlParams.get("start_date");
        var endDate = urlParams.get("end_date");

        var userId = window.location.pathname.replace("/stats/", "").replace("/custom", "");

        var readStatus = $(`#${chartID}`).parent().prevAll('.chart-read-status').first().text()

        if ((year == "-1") && startDate && endDate) {
          $.post('/stats/segment', { chart_type: chartType, label: label, year: year, start_date: startDate, end_date: endDate, read_status: readStatus, user_id: userId });
        } else {
          $.post('/stats/segment', { chart_type: chartType, label: label, year: year, month: month, read_status: readStatus, user_id: userId });
        }
      }
    }
  }
});

$(document).on('turbo:load',function(event){
  if (document.getElementsByClassName('cover-collage').length > 0)  {
    var FlexMasonry=function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){t(1),e.exports=t(2)},function(e,n,t){},function(e,n,t){"use strict";t.r(n);const r={responsive:!0,breakpointCols:{"min-width: 1500px":6,"min-width: 1200px":5,"min-width: 992px":4,"min-width: 768px":3,"min-width: 576px":2},numCols:4};let o=null,i={},s=[];function a(){s.forEach(function(e){c(e)})}function l(){o&&window.cancelAnimationFrame(o),o=window.requestAnimationFrame(function(){y()})}function c(e){if(d()<2)return void e.style.removeProperty("height");let n=[];Array.from(e.children).forEach(function(e){if(e.classList.contains("flexmasonry-break"))return;const t=window.getComputedStyle(e),r=t.getPropertyValue("order"),o=t.getPropertyValue("height");n[r-1]||(n[r-1]=0),n[r-1]+=Math.ceil(parseFloat(o))});const t=Math.max(...n);e.style.height=t+"px"}function f(e){const n=e.querySelectorAll(".flexmasonry-break");if(Array.from(n).length!==d()-1)for(let n=1;n<d();n++){const t=document.createElement("div");t.classList.add("flexmasonry-break"),t.classList.add("flexmasonry-break-"+n),e.appendChild(t)}}function u(e){e.classList.contains("flexmasonry-cols-"+d())||(e.className=e.className.replace(/(flexmasonry-cols-\d+)/,""),e.classList.add("flexmasonry-cols-"+d()))}function d(){if(!i.responsive)return i.numCols;const e=Object.keys(i.breakpointCols);for(const n of e)if(window.matchMedia("("+n+")").matches)return i.breakpointCols[n];return 1}function m(e,n={}){return i=Object.assign(r,n),u(e),function(e){const n=e.querySelectorAll(".flexmasonry-break");Array.from(n).length!==d()-1&&Array.from(n).forEach(function(e){e.parentNode.removeChild(e)})}(e),f(e),c(e),this}function y(e={}){return s.forEach(function(n){m(n,e)}),this}n.default={init:function(e,n={}){return s="string"==typeof e?document.querySelectorAll(e):e,i=Object.assign(r,n),s.forEach(function(e){!function(e){e.classList.add("flexmasonry"),i.responsive&&e.classList.add("flexmasonry-responsive"),u(e),Array.from(e.children).forEach(function(e){e.classList.add("flexmasonry-item")}),f(e)}(e),c(e)}),window.addEventListener("load",a),window.addEventListener("resize",l),this},refresh:m,refreshAll:y,destroyAll:function(){window.removeEventListener("load",a),window.removeEventListener("resize",l)}}}]).default;

    setTimeout(function(){
      FlexMasonry.init('.cover-collage', {
        responsive: false,
        numCols: 4
      });
    }, 1000);
setTimeout(function(){
  FlexMasonry.init('.cover-collage', {
    responsive: false,
    numCols: 4
  });
}, 5000);
setTimeout(function(){
  FlexMasonry.init('.cover-collage', {
    responsive: false,
    numCols: 4
  });
}, 10000);
}
})

// Show loading spinner and hide reviews when the outer reviews frame navigates.
// Uses event delegation on document so it's attached once (not per frame load).
// Only triggers when the outer frame itself is fetching (not nested frames/pagination).
document.addEventListener('turbo:before-fetch-request', function(event) {
  var target = event.target;
  // Only match if the element initiating the fetch targets the outer reviews frame.
  // For forms/links, check their data-turbo-frame; for frames, check if it IS the outer frame.
  var frameId = target.getAttribute('data-turbo-frame') || (target.tagName === 'TURBO-FRAME' && target.id);
  if (frameId !== 'book-reviews-content' && frameId !== 'user-reviews-content') return;
  var frame = document.getElementById(frameId);
  if (!frame) return;

  var isBook = frame.id === 'book-reviews-content';
  var spinner = document.getElementById(isBook ? 'book-reviews-loading' : 'user-reviews-loading');
  var reviews = isBook ? document.getElementById('book_reviews') : document.querySelector('.review-panes');
  if (spinner) spinner.classList.remove('hidden');
  if (reviews) reviews.classList.add('hidden');
});

import "controllers"
